<template>
  <div>
    <!-- 附加服务 售后 售中通用 routrName-->
    <el-dialog :title="$t('message.additionalServices')" :close-on-click-modal="false"
      :visible.sync="$parent.optionsDialogVisible" width="1000px" center>
      <!-- 售中显示 -->
      <p class="note" v-if="routrName == 'inSaleList'">注意：修改前，请先确认当前商品在什么状态，如需其他岗位暂停操作的，请先联系暂停操作！！！！</p>
      <div class="option">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!--附加服务选择  -->
            <li class="flex15">
              {{ $t("message.additionalServiceOptions") }}
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              {{ $t("message.additionalServicesJapanese") }}
            </li>
            <!--数量  -->
            <li>
              {{ $t("message.number") }}
            </li>
            <!--实际收费标准  -->
            <li class="flex15">{{ $t("message.actualCharges") }}</li>
            <!--预计费用  -->
            <li>{{ $t("message.estimatedCost") }}(元)</li>
          </ol>
          <ul v-for="(item, index) in optionsList" :key="index" v-show="item.show">
            <!--附加服务选择  -->
            <li class="flex15">
              <div class="checkbox" v-if="item.edit && item.name != '配套' && item.name != '拍照'">
                <el-checkbox v-model="item.checked"></el-checkbox>
                <div class="input">
                  <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
                </div>
              </div>
              <div class="checkbox" v-else>
                <el-checkbox v-model="item.checked">({{ index + 1 }}) {{ item.name }}</el-checkbox>
              </div>
            </li>
            <!--附加服务日文  -->
            <li class="flex15">
              <el-input v-model="item.name_translate" size="small" onfocus="this.select()"
                :placeholder="$t('message.additionalServicesJapanese')"
                v-if="item.edit && item.name != '配套' && item.name != '拍照'"></el-input>
              <span v-else>
                {{ item.name_translate }}
              </span>
            </li>
            <!--数量  -->
            <li>
              <el-input v-model="item.num" size="small" onfocus="this.select()"
                @input="handleInput(item.num, index)"></el-input>
            </li>
            <li class="flex15">
              <div class="template">
                <div class="input" v-if="(item.name == '配套' || item.name == '拍照')">
                  <el-input v-model="item.price" size="small" onfocus="this.select()"
                    @input="handleInputPrice(item.price, index)"></el-input>
                </div>
                <div class="input" v-else>
                  <el-input v-model="item.price" size="small" onfocus="this.select()"
                    @input="handleInputPrice(item.price, index)" v-if="item.edit || isEdit"></el-input>
                  <span v-else>{{ item.price }}</span>
                </div>
                {{ item.unit }}
              </div>
            </li>
            <!--预计费用  -->
            <li>
              <span class="total">
                <!-- 计算方式 当个 -->
                <span v-if="item.price_type == 0">
                  {{ item.checked ? (item.price * item.num).toFixed(2) : '' }}
                </span>
                <!-- 计算方式 % -->
                <span v-else-if="item.price_type == 1 && item.checked">
                  <!-- 售中的计算方式 -->
                  <span v-if="routrName == 'inSaleList'">

                    {{ ((itemsData.confirm_price * item.num * item.price) / 100).toFixed(2) }}
                  </span>
                  <span v-else>
                    {{ ((itemsData.offer_price_bak * item.num * item.price) / 100).toFixed(2) }}
                  </span>
                </span>
              </span>
              <el-button size="mini" type="success" class="dark fr"
                v-if="item.edit && item.name != '配套' && item.name != '拍照'" @click="delItem(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
          <!-- 操作 -->
          <div class="operation">
            <el-button size="mini" type="success" @click="add">
              新增自定义OPTION
            </el-button>
            <el-button type="primary" size="mini" @click="show = !show">
              {{ show ? '收起' : '查看更多OPTION' }}
            </el-button>
          </div>
          <!-- 更多option -->
          <div class="show" v-show="show">
            <ul v-for="(item, index) in optionsList" :key="index" v-show="!item.show">
              <!--附加服务选择  -->
              <li class="flex15">
                <div class="checkbox" v-if="item.edit && item.name != '配套' && item.name != '拍照'">
                  <el-checkbox v-model="item.checked" @change="checkedNum"></el-checkbox>
                  <div class="input">
                    <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
                  </div>
                </div>
                <div class="checkbox" v-else>
                  <el-checkbox v-model="item.checked" @change="checkedNum">{{ item.name }}</el-checkbox>
                </div>
              </li>
              <!--附加服务日文  -->
              <li class="flex15">
                <el-input v-model="item.name_translate" size="small" onfocus="this.select()"
                  :placeholder="$t('message.additionalServicesJapanese')"
                  v-if="item.edit && item.name != '配套' && item.name != '拍照'"></el-input>
                <span v-else>
                  {{ item.name_translate }}
                </span>
              </li>
              <!--数量  -->
              <li>
                <el-input v-model="item.num" size="small" onfocus="this.select()"
                  @input="handleInput(item.num, index)"></el-input>
              </li>
              <li class="flex15">
                <div class="template">

                  <div class="input" v-if="(item.name == '配套' || item.name == '拍照')">
                    <el-input v-model="item.price" size="small" onfocus="this.select()"
                      @input="handleInputPrice(item.price, index)"></el-input>
                  </div>
                  <div class="input" v-else>
                    <el-input v-model="item.price" size="small" onfocus="this.select()" v-if="item.edit || isEdit"
                      @input="handleInputPrice(item.price, index)"></el-input>
                    <span v-else>{{ item.price }}</span>
                  </div>
                  {{ item.unit }}
                </div>
              </li>
              <!--预计费用  -->
              <li>

                <span class="total">
                  {{ item.price_type }}
                  <!-- 计算方式 当个 -->
                  <span v-if="item.price_type == 0">
                    {{ item.checked ? (item.price * item.num).toFixed(2) : '' }}
                  </span>
                  <!-- 计算方式 % -->
                  <span v-else-if="item.price_type == 1 && item.checked">

                    <!-- 售中的计算方式 -->
                    <span v-if="routrName == 'inSaleList'">
                      {{ itemsData.confirm_price }}
                      {{ ((itemsData.confirm_price * item.num * item.price) / 100).toFixed(2) }}
                    </span>
                    <span v-else>
                      {{ ((itemsData.offer_price_bak * item.num * item.price) / 100).toFixed(2) }}
                    </span>
                  </span>
                </span>
                <el-button size="mini" type="success" class="dark fr"
                  v-if="item.edit && item.name != '配套' && item.name != '拍照'" @click="delItem(index)">
                  {{ $t("message.delete") }}
                </el-button>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--重置  -->
        <el-button @click="reset" v-if="routrName == 'inSaleList'">
          {{ $t("message.reset") }}
        </el-button>

        <!--取 消  -->
        <el-button @click="$parent.optionsDialogVisible = false" v-else>
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    option: { type: Array },
    itemsData: { type: Object },
    checkList: { type: Array },
  },
  data() {
    return {
      routrName: this.$route.name,
      show: false,
      optionsList: [],
      val: "",
      userId: (JSON.parse(localStorage.getItem('japanUserRoleInfo')).id + ''),
      isEdit: false,

    };
  },
  created() {

    this.isEdit = this.isAuth(712)
    // console.log(this.itemsData);

    // 获取option列表
    let datas = {
      order_detail_id: this.itemsData.order_detail_id,
      need_fix: 1,
      // user_id: this.itemsData
    }
    this.$api.orderApi.orderOptionList(datas).then((res) => {
      res.data.forEach((item, index) => {
        if (index < 9) {
          item.show = true
        } else {
          item.show = false

        }
      })
      this.optionsList = res.data;
      this.optionsList.forEach(item => {
        if (item.name != '配套' && item.name != '拍照') {
          item.edit = false
        }
        if (item.price == 0 || item.price == null) {
          item.edit = true
        }
      })
      if (this.option != false && this.option != null) {
        this.option.forEach((item) => {
          let flag = this.optionsList.every((items) => item.name != items.name);
          // console.log(flag);

          if (flag) {
            this.optionsList.push(item);
          }
          this.optionsList.forEach((items) => {
            if (item.name == items.name) {
              items.num = item.num;
              items.checked = item.checked;
              items.price = item.price;
              items.show = true
            }
          });
        });
        this.checkedNum()
      }

    });
  },
  methods: {
    add() {
      this.optionsList.push({
        auto_calculate: 0,
        checked: false,
        edit: true,
        is_overstep: 0,
        name: "",
        name_translate: '',
        price_type: 0,
        price: "",
        num: "",
        unit: '元',
        show: true
      });
    },
    delItem(i) {
      this.optionsList.splice(i, 1);
    },
    //默认数量
    checkedNum() {
      this.optionsList.forEach(item => {
        if (item.checked) {
          item.show = true

        } else {
          item.num = 0
        }
      })
      this.$forceUpdate()
    },
    // 保存
    save() {
      let options = [];
      for (let i = 0; i < this.optionsList.length; i++) {
        if (this.optionsList[i].checked) {
          if (this.optionsList[i].name == '') {
            return this.$message.error('option中文名称不能为空')
          }
          if (this.optionsList[i].name_translate == '') {
            return this.$message.error('option日文名称不能为空')
          }
          if (this.optionsList[i].price === '') {
            return this.$message.error(this.optionsList[i].name + 'option价格为空')
          }
          let list = this.optionsList.filter(item => item.name.trim() == this.optionsList[i].name.trim())
          //只能存在一个唯一的option中文名
          if (list.length > 1) {
            return this.$message.error('option中文名称不能一致可以加个（新）之类的，比如详细检品（新）')
          }
          // 详细检品低于30重新计算 || this.optionsList[i].name == '详细检品(单价)'
          if (this.optionsList[i].name == '详细检品') {
            // 售中confirm_price 售后 pre_price
            let price = this.routrName == 'inSaleList' ? this.itemsData.confirm_price : this.itemsData.pre_price
            if (price <= 30) {
              options.push(
                {
                  auto_calculate: 1,
                  checked: true,
                  edit: false,
                  is_overstep: 0,
                  name: "详细检品(单价)",
                  name_translate: "詳細検品",
                  price_type: 0,
                  price: price > 15 ? 2 : 1.5,
                  num: this.optionsList[i].num,
                  unit: '元'
                }
              )
            } else {
              options.push(this.optionsList[i]);
            }
          } else if (this.optionsList[i].name == '拍照') {
            // 拍照张数计算
            let price = 0
            if (this.optionsList[i].num == 1) {
              price = 12
            } else if (this.optionsList[i].num >= 2 && this.optionsList[i].num <= 5) {
              price = 40
            } else if (this.optionsList[i].num >= 6 && this.optionsList[i].num <= 8) {
              price = 60
            } else if (this.optionsList[i].num > 8) {
              let num = this.optionsList[i].num - 8
              price = 60
              price += num * 7
            }

            options.push(
              {
                auto_calculate: 0,
                checked: true,
                edit: false,
                is_overstep: 0,
                name: `摄影(${this.optionsList[i].num}张)`,
                name_translate: `写真(${this.optionsList[i].num}枚)`,
                price_type: 0,
                price,
                num: 1,
                unit: '元'
              }
            )

          }
          else {
            options.push(this.optionsList[i]);
          }
        }
      }
      // 数组去重
      var hash = {};
      options = options.reduce(function (items, next) {
        hash[next.name]
          ? ""
          : (hash[next.name] = true && items.push(next));
        return items;
      }, []);
      let datas = {
        data: [],
      };
      // 售中参数
      let inSaleData = {
        ids: [],
        new_option: JSON.stringify(options),
      }
      // 
      this.checkList.forEach(item => {

        datas.data.push({
          problem_goods_id: item.problem_goods_id,
          option_new: JSON.stringify(options),
        },)
        inSaleData.ids.push(item.id)
      })
      // 售后的时候执行
      if (this.routrName != 'inSaleList') {
        this.$api.problemApi.updateOption(datas).then((res) => {
          this.$message.success(res.msg);
          this.$parent.successOption(options);
        });
      } else { //售中
        this.$api.inSaleApi.updateNewOption(inSaleData).then((res) => {
          this.$message.success(res.msg);
          this.$parent.successOption(options);
        });
      }


      // this.$api.problemApi.updateOption()
      // this.$parent.detail.order_detail[this.$parent.i].option = options;
      // this.$parent.optionsDialogVisible = false;
      // this.$parent.computationalSost();
    },
    // 重置
    reset() {
      this.optionsList.forEach(item => {
        item.checked = false
        item.num = 0
      })
    },
    // 是否输入的小数
    handleInput(value, index) {
      // 使用正则表达式来判断是否输入了小数
      const regex = /^(\d+)?(\.\d{1,2})?$/;
      if (!regex.test(value)) {
        // 如果输入的不是小数，则将其设置为上一次的值
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('.', '');
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('-', '');
        this.optionsList[index].num = this.optionsList[index].num.replace(/[^\d^]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      }
    },
    // 不能输入负数
    handleInputPrice(value, index) {
      this.optionsList[index].price = ("" + this.optionsList[index].price) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数

    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  margin-bottom: 20px;
  max-height: 650px;
  overflow-y: auto;

  ol {

    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex2 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}

.operation {
  margin-top: 10px;

  .el-button {
    margin-right: 200px;
  }
}

.note {
  margin-bottom: 20px;
  color: red;
  font-size: 16px;
}
</style>